import Input from "../../controls/Input";
import SelectMenu from "../../controls/SelectMenu";
import { useForm } from "../useForm";
import { useEffect, useState } from "react";
import { formatDateWithTime, labSampleOptions } from "../../../shared/utility";
import MediaUi from "../../importMedia/MediaUi";
import AuditActionLink from "../../audit/AuditActionLink";
import Button from "../../controls/Button";

const initialFValues = {
  name: "",
  correct_items: [],
  wrong_items: [],
  items_missing: [],
  status: { value: -1, label: "" },
  laboratory: {},
};

export default function LabSampleDetailsForm(props) {
  const { loading, inProgress, labs, labSample, updateLabSample } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    true,
    validate
  );

  useEffect(() => {
    if (!loading && labSample) {
    var statusSelected = [];
    statusSelected = labSampleOptions.find(
      (el) => el.value === labSample.status
    );

    setValues({
      ...labSample,
      status: statusSelected,
      laboratory: {
        value: labSample?.laboratory?.id ?? null,
        label: labSample?.laboratory?.name ?? "",
      },
    });
    }
  }, [labSample]);

  const [media1, setMedia1] = useState(null);
  const [media2, setMedia2] = useState(null);
  const [media3, setMedia3] = useState(null);

  const saveLabSample = async () => {
    const saved = await updateLabSample(values);
    if (saved) {
      setMedia1(null);
      setMedia2(null);
      setMedia3(null);
    }
  };

  return (
    <div className="justify-between">
      {loading? "Loading" : (
        <div>
          <div className="hide-for-print">
        <div className="flex items-center">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Lab Sample: #{labSample.id}
          </h3>
          {labSample?.id ? (
            <AuditActionLink
              slug="lab-sample"
              id={labSample.id}
              name={labSample.lot_number}
            />
          ) : null}
        </div>
      </div>

      <div className="pt-6 pb-5 grid grid-cols-1 gap-2">
        <div className="p-4 card-custom space-y-5">
          <div className="grid sm:grid-cols-4 gap-4">
            <SelectMenu
              handleInputChange={handleInputChange}
              name="laboratory"
              options={labs}
              value={values.laboratory}
              title={"Laboratory"}
              error={errors.laboratory}
              showLabel={true}
              disabled={values.status.value > 0}
            />

            <Input
              label="Date"
              name="created_at"
              value={formatDateWithTime(values.created_date)}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Created by"
              name="created_by_name"
              value={values.created_by_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <SelectMenu
              handleInputChange={handleInputChange}
              name="status"
              options={labSampleOptions}
              value={values.status}
              title={"Status"}
              error={errors.status}
            />

            <Input
              label="Lot number"
              value={values.lot_number}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Product name"
              value={values.product_name}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="PLU"
              value={values.plu}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />
          </div>
          <div className="grid sm:grid-cols-4 gap-4">
            <Input
              label="Amount in kg"
              value={values.weight_in_kg}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Amount in lbs"
              value={values.weight_in_lbs}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Amount in pieces"
              value={values.piece_count}
              labelOn={true}
              type="text"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />

            <Input
              label="Barcode"
              value={values.barcode}
              labelOn={true}
              type="text"
              parentClass="col-span-2"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm w-48"
              disabled={true}
            />
          </div>
        </div>

        <div className="px-2 py-4 sm:px-5 card-custom grid grid-cols-1 sm:grid-cols-3 gap-4">
          <MediaUi
            title="Document 1"
            uploadedImage={media1}
            setUploadedImage={setMedia1}
            isEdit={true}
            imageUrl={values.media_1_url}
            imageName="uploaded_media_1"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_1: null,
                media_1: "",
                media_1_url: null,
              });
              setMedia1(null);
            }}
          />

          <MediaUi
            title="Document 2"
            uploadedImage={media2}
            setUploadedImage={setMedia2}
            isEdit={true}
            imageUrl={values.media_2_url}
            imageName="uploaded_media_2"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_2: null,
                media_2: "",
                media_2_url: null,
              });
              setMedia2(null);
            }}
          />

          <MediaUi
            title="Document 3"
            uploadedImage={media3}
            setUploadedImage={setMedia3}
            isEdit={true}
            imageUrl={values.media_3_url}
            imageName="uploaded_media_3"
            handleInputChange={handleInputChange}
            onDelete={() => {
              setValues({
                ...values,
                uploaded_media_3: null,
                media_3: "",
                media_3_url: null,
              });
              setMedia3(null);
            }}
          />
        </div>
        <div>
          <Button
            type="button"
            className="mt-3"
            onClick={saveLabSample}
            loading={inProgress}
          >
            Save
          </Button>
        </div>
      </div>
        </div>
      )}
    </div>
  );
}
